import React, { useEffect } from 'react';
import { View } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, Reanimated3DefaultSpringConfig, withSpring, } from 'react-native-reanimated';
import { rem } from './values';
export const HISTOGRAM_BAR_SIZE_CHART = {
    wide: rem(54),
    medium: rem(40),
};
const RADIUS = rem(10);
export const HistogramBar = ({ upsideDown = false, color, height, size, style, ...otherProps }) => (<View style={[
        style,
        { backgroundColor: color, height, width: HISTOGRAM_BAR_SIZE_CHART[size] },
        upsideDown ? styles.downwards : styles.upwards,
    ]} {...otherProps}/>);
export const AnimatedHistogramBar = (({ upsideDown = false, color, height: H, size, style, ...otherProps }) => {
    const height = useSharedValue(0);
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            height.value = withSpring(H, {
                ...Reanimated3DefaultSpringConfig,
                mass: 0.8,
                stiffness: 100,
            });
        }, 350);
        return () => clearTimeout(timeoutId);
    }, [H]);
    const animatedStyle = useAnimatedStyle(() => ({
        height: height.value,
    }));
    return (<Animated.View style={[
            style,
            { backgroundColor: color, width: HISTOGRAM_BAR_SIZE_CHART[size] },
            animatedStyle,
            upsideDown ? styles.downwards : styles.upwards,
        ]} {...otherProps}/>);
});
const styles = {
    upwards: {
        borderTopLeftRadius: RADIUS,
        borderTopRightRadius: RADIUS,
    },
    downwards: {
        borderBottomLeftRadius: RADIUS,
        borderBottomRightRadius: RADIUS,
    },
};
